import React from "react";
import PropTypes from "prop-types";
import styles from "./PopupPitchSkeleton.module.css";

export default function PopupPitchSkeleton({ compact = false }) {
  return (
    <div
      className={`${styles.root} ${compact ? styles.compact : ""}`.trim()}
      aria-hidden
    >
      <span className={`${styles.bar} ${styles.barLabel}`} />
      <span className={`${styles.bar} ${styles.barWide}`} />
      {!compact ? <span className={`${styles.bar} ${styles.barMid}`} /> : null}
    </div>
  );
}

PopupPitchSkeleton.propTypes = {
  compact: PropTypes.bool,
};
